import React, { useState } from 'react'
import { Container, Row, Col, Button, Spinner } from 'react-bootstrap'
import { TextField } from '@material-ui/core';
import axios from "axios"
import { base_url } from '../globalConstants';
import './common.css'
import { useHistory } from 'react-router-dom';

const Calculator = () =>{

    const [length, setLength] = useState(0)
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)
    const [weight, setWeight] = useState(0)
    const [fedexCharge, setFedexCharge] = useState(0)
    const [actualCharge, setActualCharge] = useState(0)
    const [isCalculating, setIsCalculating] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
	const history = useHistory();

	
    const handleLength = e => {
        setIsError(false)
        // console.log(e.target.value)
        setLength(e.target.value)
    }
    
    const handleWidth = e => {
        setIsError(false)
        // console.log(e.target.value)
        setWidth(e.target.value)
    }
    
    const handleHeight = e => {
        setIsError(false)
        // console.log(e.target.value)
        setHeight(e.target.value)
    }
    
    const handleWeight = e => {
        setIsError(false)
        // console.log(e.target.value)
        setWeight(e.target.value)
        // calculateFedexCharge()
    }
    const onHome = async () => {
		history.push('/customerdashboard');
	}
    const calculateFedexCharge = async () => {     
        // e.preventDefault()
        
        setErrorMessage('')
        setIsError(false)
        setIsCalculating(true)
        var fedex_value
        //let url = base_url+`fedex_actual_rates/?weight=${weight}&height=${height}&breadth=${width}&length=${length}&ezz_id=${localStorage.getItem('ezzyid')}`
		var c_length = Math.ceil(length)
		var c_height = Math.ceil(height)
		var c_width = Math.ceil(width)
		console.log(c_length)
		console.log(c_height)
		console.log(c_width)
		
		let url = base_url+`fedex_actual_rates/?weight=${weight}&height=${c_height}&breadth=${c_width}&length=${c_length}&ezz_id=${localStorage.getItem('ezzyid')}&method=${localStorage.getItem('shipmethod')}`
        
        if(length <= 0 || height <= 0 || width <= 0 || weight <= 0)
        {
            // console.log('INSIDE IF')
            setIsCalculating(false)
            setIsError(true)
            setErrorMessage('Error Calculating: invalid values')
            setFedexCharge(0)
            setActualCharge(0)
        }else{
            setIsError(false)
            setErrorMessage('')
            fedex_value = await axios.get(url).then(res=>{
                setIsCalculating(false)
                // setFedexCharge(res.data.freight_charges)
                setActualCharge(res.data.actual_charges)
            }).catch(err=>{
                console.log('ERR',err);
                setIsCalculating(false)
                setFedexCharge(0)
                setActualCharge(0)
                setIsError(true)
                setErrorMessage('Error Calculating')
            })
        }
    }

    return(
        <>            
            <Container>

                <Row>
				<Col xs lg={9}>
				<br/><br/>
				{/* <h4>Calculate Shipping Charge</h4> */}
					<h2 className="general-heading" >Calculate Shipping Charge</h2>
					</Col>
                </Row><br/>
                <Row>
                    <Col style={{textAlign: 'center'}}>
                        <div>
                            {
                                isCalculating
                                    ?
                                    < div className="center">

                                        <Spinner animation="grow" variant="primary" size="sm" />
                                        <Spinner animation="grow" variant="success" size="sm" />
                                        <Spinner animation="grow" variant="warning" size="sm" />
                                    </div>
                                    : isError
                                        ? <h4 style={{color: 'red'}}>{errorMessage}</h4>
                                        :''
                            }
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 10 }}>
                        <h5>Shipping Charge</h5>
                        <form >
                            <Row>
                                <Col>
                                    <h6>Enter Length</h6>
                                    <TextField type='number' id="length" label="Length" variant="filled"
                                        className='textField' fullWidth
                                        helperText = 'Length in inches'
                                        onChange={handleLength} value={length} />                                    
                                </Col>
                                <Col>
                                    <h6>Enter Width</h6>
                                    <TextField type='number' id="width" label="Width" variant="filled"
                                        className='textField' fullWidth
                                        helperText = 'Width in inches'
                                        onChange={handleWidth} value={width} />
                                </Col>
                                <Col>
                                    <h6>Enter Height</h6>
                                    <TextField type='number' id="height" label="Height" variant="filled"
                                        className='textField' fullWidth
                                        helperText = 'Height in inches'
                                        onChange={handleHeight} value={height} />
                                </Col>
                                {/* <Col></Col> */}
                            </Row><br/>
                            <Row>
                                <Col>
                                    <h6>Enter Weight</h6>
                                    <TextField type='number' id="weight" label="Weight" variant="filled"
                                        className='textField' fullWidth
                                        helperText = 'Weight in pounds'
                                        onChange={handleWeight} value={weight} />
                                </Col>
                                {/* <Col>
                                    <h6>Calculated Fedex Charge</h6>
                                    <TextField id="fedexCharge" className='textField' label="Fedex Charge" variant="filled" disabled fullWidth                                        
                                        value={fedexCharge}  helperText='Auto generated ($)'                                       
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                </Col> */}
                                <Col>
                                    <h6>Calculated  Actual Freight Charge</h6>
                                    <TextField id="actualCharge" className='textField' label="Actual Charge " variant="filled" disabled fullWidth                                        
                                        value={actualCharge}  helperText='Auto generated ($)'                                       
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <div style={{ margin: '10% 0', display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                        <Button id="btnCalculate" className="btnCalculate" variant="primary" type='button' size='lg' block                                         
                                            onClick= { calculateFedexCharge  }>Calculate</Button>
											
<Button id="btnhome" className="btnCalculate" variant="primary" type='button' size='lg' block                                         
                                            onClick= { onHome  }>Home</Button>											
                                    </div>
                                </Col>
                            </Row><br/>
                            <Row>
                            </Row>
                        </form>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Calculator